import { literal, preprocess } from 'zod';

import { ProductChallengeEarningMechanismSchema } from '@occc-app/routes/Challenge/schemas';

import { BaseSweepstakesSchema } from './base-sweepstakes.schema';

import { SweepstakesType } from '../types';

export const VarietyChallengeFormSchema = BaseSweepstakesSchema.extend({
  sweepstakesType: literal(SweepstakesType.VarietyChallenge),
  productChallenge: preprocess((value) => value ?? {}, ProductChallengeEarningMechanismSchema),
});
